<template>
  <Modal position="end" width="45rem" ref="modalRef">
    <template #header>Application</template>

    <template #body>
      <View direction="column" gap="md">
        <Text variant="h2">{{ renterProfileStore.profile.profile?.user.name }}</Text>
        <PersonalDetailsCard :personal-details="application.renterDetails" />
        <PetDetailsCard :personal-details="application.renterDetails" :pet-photos="application.petPhotos" />
        <EmploymentCard :employment-info="application.employmentInfo" />
        <ResidenceInfoCard :residence-info="application.residenceInfo" />
        <DocumentsCard :application="application" />
        <ReferenceDetailsCard :reference-details="reference" />
      </View>
    </template>

    <template #footer>
      <Button @click="modalRef?.close()">Close</Button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import {
  ApplicationWithRenterDto,
  DocumentsCard,
  EmploymentCard,
  PersonalDetailsCard,
  PetDetailsCard,
  ReferenceDetailsCard,
  ResidenceInfoCard,
} from '@tallo/applications';
import { Button, Modal, Text, View } from '@tallo/design-system';

import { useRenterProfileStore } from '../store/renter-profile.store';

const renterProfileStore = useRenterProfileStore();

const props = defineProps<{ application: ApplicationWithRenterDto }>();

const modalRef = ref<InstanceType<typeof Modal>>();

const reference = computed(() => props.application.references[0]);

defineExpose({ modalRef });
</script>

<style scoped lang="scss"></style>
